module.exports = __webpack_public_path__ + "static/media/tree_anim.ab682221.webp";